'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Seminar = void 0;
var config_1 = require("../config");
var Func = require("../func");
var $ = require("jquery");
var Seminar = /** @class */ (function () {
    function Seminar(notNullKeys) {
        var _this = this;
        if (notNullKeys === void 0) { notNullKeys = ['seminar_date', 'join_method', 'group_name', 'your_name', 'telno', 'postal_code', 'prefecture', 'address01', 'email', 'accept']; }
        this.notNullKeys = notNullKeys;
        this.OVER_PC_WIDTH = config_1.default.OVER_PC_WIDTH;
        this.HEADER_HEIGHT = config_1.default.HEADER_HEIGHT;
        var self = this;
        $('#trigSeminarFormSubmit').on('click', function () {
            $('.bulletSeminarFormErrorMessage').hide();
            var values = _this.getValues();
            return _this.validates(values);
        });
    }
    Seminar.prototype.getValues = function () {
        return {
            seminar_date: $('.paramContactValue[data-name="seminar_date"]:checked').val(),
            join_method: $('.paramContactValue[data-name="join_method"]:checked').val(),
            group_name: $('.paramContactValue[data-name="group_name"]').val(),
            your_name: $('.paramContactValue[data-name="your_name"]').val(),
            telno: $('.paramContactValue[data-name="telno"]').val(),
            postal_code: $('.paramContactValue[data-name="postal_code"]').val(),
            prefecture: $('.paramContactValue[data-name="prefecture"] option:checked').val(),
            address01: $('.paramContactValue[data-name="address01"]').val(),
            email: $('.paramContactValue[data-name="email"]').val(),
            email_re: $('.paramContactValue[data-name="email_re"]').val(),
            accept: $('.paramContactValue[data-name="accept"]:checked').val(),
        };
    };
    Seminar.prototype.validates = function (values) {
        var self = this;
        var errorFlag = false;
        var scrollToNames = [];
        // 空白チェック
        this.notNullKeys.forEach(function (v) {
            if (Func.isNull(values[v])) {
                errorFlag = true;
                $(".bulletSeminarFormErrorMessage[data-name=\"" + v + "\"]").show();
                scrollToNames.push(v);
                // console.log(v);
            }
            if (v === 'postal_code' || v === 'prefecture' || v === 'address01') {
                scrollToNames.push('address');
            }
            if (v === 'telno') {
                // 電話フォーマット
                if (!Func.isNull(values.telno) && !self.matchTelFormat(values.telno)) {
                    errorFlag = true;
                    $('.bulletSeminarFormErrorMessage[data-name="telno_not_matched"]').show();
                    scrollToNames.push('telno');
                }
            }
            if (v === 'email') {
                // メールフォーマット
                if (!Func.isNull(values.email) && !self.matchEmailFormat(values.email)) {
                    errorFlag = true;
                    $('.bulletSeminarFormErrorMessage[data-name="email_not_matched"]').show();
                    scrollToNames.push('email');
                }
                // メール再入力
                if (values.email != values.email_re) {
                    errorFlag = true;
                    $('.bulletSeminarFormErrorMessage[data-name="email_not_confirmed"]').show();
                    scrollToNames.push('email');
                }
            }
        });
        // エラー時処理
        if (errorFlag) {
            this.scrollToError(scrollToNames[0]);
            return false;
        }
    };
    Seminar.prototype.scrollToError = function (errorName) {
        var windowWidth = $(window).outerWidth();
        var headerHeight = 0;
        if (this.OVER_PC_WIDTH <= windowWidth) {
            headerHeight = this.HEADER_HEIGHT;
        }
        var formPosition = $('.bulletContactError[data-name="' + errorName + '"]').offset().top;
        $('html, body').animate({
            scrollTop: formPosition - headerHeight
        }, 'slow');
    };
    // 空白文字の削除
    Seminar.prototype.removeSpace = function (val) {
        return val ? val.replace(/\s+/g, '') : '';
    };
    // 電話番号のフォーマットチェック
    Seminar.prototype.matchTelFormat = function (val) {
        return val.match(/[0-9]{2,4}[\-]{0,1}[0-9]{2,4}[\-]{0,1}[0-9]{2,4}/);
    };
    // メールのフォーマットチェック
    Seminar.prototype.matchEmailFormat = function (val) {
        return val.match(/^[0-9a-zA-Z]+[0-9a-zA-Z\-\+_\.]+@[0-9a-zA-Z\-\+_\.]+\.[0-9a-zA-Z\-\+_\.]+$/g);
    };
    return Seminar;
}());
exports.Seminar = Seminar;
exports.default = Seminar;
